export class PractitionerSpecialty {
  private key: string;
  private description: string;

  constructor() {}

  public getKey(): string {
    return this.key;
  }

  public setKey(value: string): void {
    this.key = value;
  }

  public getDescription(): string {
    return this.description;
  }

  public setDescription(value: string): void {
    this.description = value;
  }
}
